<template>
    <button class="text-left" @click="showProDialog">
        <div
            class="group flex rounded-lg border border-iron-200 p-[10px] transition-all duration-150 group-hover:shadow-md"
        >
            <div class="mr-3 flex items-center">
                <slot name="icon"></slot>
            </div>

            <div class="w-full">
                <p
                    class="flex items-center gap-2 text-sm font-medium leading-5 text-iron-700"
                >
                    <slot name="title"></slot>

                    <PaidFeatureIcon v-if="isPaid && !hasSubscription" />
                </p>

                <p class="max-w-sm text-sm leading-5 text-iron-500">
                    <slot name="description"></slot>
                </p>
            </div>

            <div class="flex items-center justify-self-end">
                <ChevronRight
                    class="h-6 w-6 text-iron-500 transition-all duration-150 group-hover:translate-x-1"
                />
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
import { ChevronRight } from "lucide-vue-next";
import PaidFeatureIcon from "./PaidFeatureIcon.vue";
import { useHasSubscription } from "@/composables/useHasSubscription";
import useProDialog from "@/ProModal/composables/useProDialog";

interface Props {
    isPaid: boolean;
    feature?: string;
}

const props = withDefaults(defineProps<Props>(), {
    isPaid: true,
});

const { hasSubscription } = useHasSubscription();
const proDialog = useProDialog();

function showProDialog() {
    proDialog.show({
        feature: props.feature,
    });
}
</script>
